 /* eslint-disable */
import { accessNestedProperty } from '../../../../helpers/general'

const SORT_BY_MAP = {
    firstName: 'name.givenName',
    lastName: 'name.familyName',
    status: 'status',
    email: 'emails.0.value',
    lastLogin: 'meta.lastLogin'
  };

export const sortUsers = ({ users = [], sortBy, sortOrder }) => [...users].sort((a, b) => {
    const isAsc = sortOrder === 'asc';
    return isAsc ? accessNestedProperty(a, SORT_BY_MAP[sortBy]).localeCompare(accessNestedProperty(b, SORT_BY_MAP[sortBy]))
    : accessNestedProperty(b, SORT_BY_MAP[sortBy])
    .localeCompare(accessNestedProperty(a, SORT_BY_MAP[sortBy]));
});
